import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ImageSlider = ({ images }) => {
  const settings = {
    dots: false,
    infinite: images?.length > 4,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: images?.length > 4 && 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024, // Adjust this value as needed
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: images?.length > 1,
          dots: true,
        },
      },
      {
        breakpoint: 768, // Adjust this value as needed
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: images?.length > 1,
          dots: true,
        },
      },
      {
        breakpoint: 480, // Adjust this value as needed
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: images?.length > 1,
          dots: true,
        },
      },
    ],
  };

  return (
    <div className="flex w-full">
      <div className="w-full bg-white">
        <Slider {...settings}>
          {images?.map((image, index) => (
            <div key={index} className="px-2">
              <img
                src={image?.url}
                alt={`Slide ${index}`}
                className="rounded-md"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} slick-arrow right-2 top-1/2 transform -translate-y-1/2`}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="currentColor"
        className="text-gray-700"
      >
        <path
          d="M4.5 11.5L0 5H3L4.5 6.73809L9.5 0.5H13L8.75 6L4.5 11.5Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} slick-arrow left-2 top-1/2 transform -translate-y-1/2`}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="currentColor"
        className="text-gray-700"
      >
        <path
          d="M4.5 11.5L0 5H3L4.5 6.73809L9.5 0.5H13L8.75 6L4.5 11.5Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export default ImageSlider;
